query RevitParameterTemplates {
    revitParameterTemplates {
        id
        parameterID
        ... on RevitBuiltInParameterTemplate {
            bimClassID
            revitBuiltInParameterID
        }
        ... on RevitSharedParameterTemplate {
            revitSharedParameterDefinition {
                group
                instance
                modifiable
                type
                visible
            }
        }
    }
}
